import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "jsTopBlocks addScrollDownToContent _productDetails-topBlocks" }

import { loadingProgressKey } from '@drapejs/core';

  import { computed, inject, nextTick, provide, ref, watch } from 'vue';
  import { useGA4 } from '@distancify-storefront/tracking-gtm';
  import useContext from '@/composables/useContext';
  import useMeta from '@/composables/useMeta';
  import useReviews from '@/composables/useReviews';

  import ScrollDownToContent from '../components/ScrollDownToContent.vue';
  import ProductOverview from '../components/PDP/ProductOverview';
  import ProductSchema from '@/components/ProductSchema/ProductSchema.vue';
  import Reviews from '@/components/Reviews/Reviews.vue';
  import RecentlyVisitedProducts from '@/blocks/RecentlyVisitedProducts.vue';
  import { productView } from '@/helpers/voyado-engage';
  import { channelKey } from '@/keys';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Product',
  setup(__props) {

  /* eslint-disable @typescript-eslint/camelcase */

  const loadingProgress = inject(loadingProgressKey, ref(null));

  const channel = inject(channelKey);
  const { page, cart } = useContext();
  useReviews();

  const blocks = computed(() => page?.value.blocks);
  const product = computed(() => page?.value.dataJson?.product);
  provide('product', product);

  const pdpDetails = computed(() => product.value?.pdpDetails);
  provide('pdpDetails', pdpDetails);

  const scrollTarget = ref<HTMLElement | null>(null);

  let preservedScrollPosition: null | number = null;
  function preserveScrollPosition() {
    if (!scrollTarget.value) return;
    preservedScrollPosition = scrollTarget.value.getBoundingClientRect().top;
  }

  provide('preserveScrollPosition', preserveScrollPosition);

  const hidePrice = computed(() => product.value?.ShowPrice || false);

  const isLocked = computed(() => {
    return page.value?.dataJson?.product?.isLocked || false;
  });

  useMeta();

  const ga4 = useGA4({
    useLegacyEnhancedECommerce: true,
  });

  watch(loadingProgress, () => {
    if (typeof loadingProgress.value === 'number') {
      return;
    }

    if (!product.value || product.value.isLocked) {
      return;
    }

    nextTick(() => {
      handleScroll();
      nextTick(() => {
        const val = product.value;
        ga4.viewItem(
          cart.value?.currency.id,
          {
            item_id: val.fields.ModelNumber,
            item_name: val.fields._name,
            item_color: val.fields.Color.name,
            item_color_id: val.id,
            item_category: val.googleAnalyticsCategoryPath[0],
            item_category2: val.googleAnalyticsCategoryPath[1],
            item_category3: val.googleAnalyticsCategoryPath[2],
            item_category4: val.googleAnalyticsCategoryPath[3],
            item_category5: val.googleAnalyticsCategoryPath[4],
          },
          {
            fb_contents: (val.otherVariants || []).map((v) => ({ id: v.articleNumber })),
          },
          true
        );
      });
    });

    setTimeout(() => {
      reportProductViewToVoyado();
    }, 1000);
  });

  function reportProductViewToVoyado() {
    if (!product.value || typeof window === 'undefined') return;

    const randomVariant =
      product.value.otherVariants[Math.floor(Math.random() * product.value.otherVariants.length)]?.articleNumber;
    if (!randomVariant) return;

    const categoryName = product.value.googleAnalyticsCategoryPath.join(' / ');
    productView(randomVariant, categoryName, channel?.value?.locale);
  }

  function handleScroll() {
    if (!scrollTarget.value) return;

    if (preservedScrollPosition && scrollTarget.value) {
      const currentPos = scrollTarget.value.getBoundingClientRect().top;
      window.scroll(window.scrollX, currentPos - preservedScrollPosition);
    }

    preservedScrollPosition = null;
  }

return (_ctx: any,_cache: any) => {
  const _component_blocks_repeater = _resolveComponent("blocks-repeater")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(blocks))
        ? (_openBlock(), _createBlock(_component_blocks_repeater, {
            key: 0,
            blocks: _unref(blocks).Main
          }, null, 8, ["blocks"]))
        : _createCommentVNode("", true),
      (_unref(blocks))
        ? (_openBlock(), _createBlock(_component_blocks_repeater, {
            key: 1,
            blocks: _unref(blocks).Top
          }, null, 8, ["blocks"]))
        : _createCommentVNode("", true),
      _createVNode(ScrollDownToContent, { "target-element-selector": ".vueProductDetailsPage" })
    ]),
    (!_unref(isLocked))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "scrollTarget",
          ref: scrollTarget,
          class: _normalizeClass([
      'vueProductDetailsPage',
      'product__product-details',
      _unref(hidePrice) ? 'product__product-details--noPrice' : '',
    ])
        }, [
          _createVNode(_unref(ProductOverview)),
          _createVNode(Reviews)
        ], 2))
      : _createCommentVNode("", true),
    (_unref(blocks))
      ? (_openBlock(), _createBlock(_component_blocks_repeater, {
          key: 1,
          blocks: _unref(blocks).Bottom
        }, null, 8, ["blocks"]))
      : _createCommentVNode("", true),
    _createVNode(RecentlyVisitedProducts),
    (!_unref(isLocked))
      ? (_openBlock(), _createBlock(ProductSchema, { key: 2 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})